
export default {
  data: () => ({ errors: [] }),

  methods: {
    async refineNext() {
      this.errors = [];
      try {
        await this.$store.dispatch("productsSearch/showMore");
      } catch (error) {
        this.$bugsnag.notify(error);
        this.errors.push("Something went wrong...");
      }
    },
  },
};
